import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EmployeeDeliveriesInputRequestDto } from 'src/app/_models/dto/employeedeliveriesinputrequestdto';
import { Observable, of } from 'rxjs';
import { PaginatedResult } from 'src/app/_models/pagination/pagination';
import { JobRecommendation } from 'src/app/_models/test-result-view-models/job-recommendation';
import { map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { VWEmployeeLearningProgram } from 'src/app/_models/ViewModels/vwemployeelearningprogram';
import { EmployeeSkill } from 'src/app/_models/Manage Skill Titles/employee-skill';
import { HRRecommendedJobsForEmployee } from 'src/app/_models/EmployeeModels/hr-recommended-jobs-for-employee';
import { ApplicantRolesAppliedTo } from 'src/app/_models/applicants/applicant-roles-aplied-to';
import { UniversityRecommendedJobsForEmployee } from 'src/app/_models/EmployeeModels/university-recommended-jobs-for-employee';
import { CandidateDto } from 'src/app/_models/EmployeeModels/candidateDto';
import { CountryCode } from 'src/app/_models/dto/countryCode';
import { EmployeeProfileDto } from 'src/app/_models/dto/employeeprofiledto';
import { EmployeeUploadService } from './employeeUpload.service';
import { EmployeeInfo } from 'src/app/_models/EmployeeModels/employee-info';
import { EmployeeSummariesOutputDto } from 'src/app/_models/dto/employee-summaries-output-dto';
import { PersonTypeEnum } from 'src/app/_enums/person-type-enum';
import { UiSyncService } from './ui-sync.service';

const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
      'Pragma': 'no-cache',
      'Expires': '0'
    }
  )
};

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  endpoint = environment.employeeUrl;
  baseUrl = environment.baseApiUrl;
  currentProfileInformation: any;

  private employeeProfileCache = new Map<string, Observable<any>>();
  constructor(private http: HttpClient, private employeeUploadService: EmployeeUploadService, private uiSyncService: UiSyncService) { }

  postFile(firstName: string, lastName: string, corporateCode: string, fileUpload: File) {


    const formData: FormData = new FormData();
    formData.append('Image', fileUpload, fileUpload.name);
    formData.append("LastName", lastName);
    formData.append('FirstName', firstName);
    formData.append('CorporateCode', corporateCode);
    return this.http.post(this.endpoint, formData);
  }

  getEmployees() {
    return this.http.get(this.endpoint);
  }
  async getEmployeeDeliveries(employeeDeliveriesInputRequest: EmployeeDeliveriesInputRequestDto): Promise<any> {
    return await this.http.get(this.endpoint + '/EmployeeDeliveries/', { params: { CatalyzrPersonId: employeeDeliveriesInputRequest.catalyzrPersonId, ClientId: employeeDeliveriesInputRequest.clientId.toString() }, headers: httpOptions.headers }).toPromise();
  }
  async getEmployeeByCzPersonAndClient(catalyzrPersonId: string, clientId: number, personType: string): Promise<any> {
    if (catalyzrPersonId && clientId) {
      return await this.http.get<any>(this.endpoint + '/GetEmployee/', { params: { catalyzrPersonId: catalyzrPersonId, clientId: clientId.toString(), personType: personType }, headers: httpOptions.headers }).toPromise();
    }
  }

  async getEmployeeByCzPersonId(catalyzrPersonId: string,): Promise<any> {
    if (catalyzrPersonId) {
      return await this.http.get<any>(this.endpoint + '/GetEmployeeByPersonId/', { params: { catalyzrPersonId: catalyzrPersonId }, headers: httpOptions.headers }).toPromise();
    }
  }

  updateEmpProfile(employee: EmployeeProfileDto, catalyzrPersonId, clientId): Observable<any> {
    const key = `${catalyzrPersonId}_${clientId}`;

    return this.http.post(this.baseUrl + 'EmployeeUploads/updateemployeeprofile', employee).pipe(
      tap(() => {
        this.employeeProfileCache.delete(key);
        this.employeeUploadService.employeeProfileImageCache.delete(catalyzrPersonId)
      })
    );
  }




  getEmployeeProfile(catalyzrPersonId: string, clientId: number): Observable<any> {
    const cacheKey = `${catalyzrPersonId}_${clientId}_${this.uiSyncService.currentUserPersonType}`;
    if (!this.uiSyncService.currentUserPersonType) {
      this.uiSyncService.currentUserPersonType = PersonTypeEnum.Employee;
    }
    if (!this.employeeProfileCache.has(cacheKey)) {
      this.employeeProfileCache.set(
        cacheKey,
        this.http.get<any>(`${this.endpoint}/getEmployeeProfile/`, {
          params: {
            catalyzrPersonId,
            clientId: clientId.toString(),
            personType: this.uiSyncService.currentUserPersonType
          },
          headers: httpOptions.headers
        }).pipe(shareReplay(1))
      );
    }

    return this.employeeProfileCache.get(cacheKey)!;
  }



  getEmployeeCurrentCareerInfo(catalyzrPersonId, clientId, personType) {
    return this.http.get(this.endpoint + '/getCurrentCareerInfo', { params: { CatalyzrPersonId: catalyzrPersonId, ClientId: clientId, PersonType: personType }, headers: httpOptions.headers });
  }
  getHRRecommendedCareerInfo(catalyzrPersonId, clientId, jobCode, requisitionId?) {
    let params = new HttpParams();
    params = params.append('clientId', clientId.toString());
    params = params.append('catalyzrPersonId', catalyzrPersonId);
    params = params.append('jobCode', jobCode);
    if (requisitionId != null) {
      params = params.append('requisitionId', requisitionId);

    }
    return this.http.get(this.endpoint + '/getHrRecommendedCareerInfo', { params, headers: httpOptions.headers });
  }

  getUniversityRecommendedCareerInfo(catalyzrPersonId, clientId, jobCode, requisitionId?) {
    let params = new HttpParams();
    params = params.append('clientId', clientId.toString());
    params = params.append('catalyzrPersonId', catalyzrPersonId);
    params = params.append('jobCode', jobCode);
    if (requisitionId != null) {
      params = params.append('requisitionId', requisitionId);

    }
    return this.http.get(this.endpoint + '/getUniversityRecommendeCareerInfo', { params, headers: httpOptions.headers });
  }
  getEmployeeToDo(catalyzrPersonId: string, clientId: number): Observable<any> {
    return this.http.get<any>(this.endpoint + '/getEmployeeTodoAndResult/', { params: { catalyzrPersonId: catalyzrPersonId, clientId: clientId.toString() }, headers: httpOptions.headers });
  }

  getEmployeeJobRecommendations(catalyzrPersonId: string, clientId: number, personType: string): Observable<any> {
    return this.http.get<any>(this.endpoint + '/getRecommendations/', { params: { catalyzrPersonId: catalyzrPersonId, clientId: clientId.toString(), PersonType: personType }, headers: httpOptions.headers });
  }

  getUniversityJobRecommendations(catalyzrPersonId: string, clientId: number, personType: string): Observable<any> {
    return this.http.get<any>(this.endpoint + '/getUniversityRecommendations/', { params: { catalyzrPersonId: catalyzrPersonId, clientId: clientId.toString(), PersonType: personType }, headers: httpOptions.headers });
  }

  getApplicantRolesAppliedTo(catalyzrPersonId: string, clientId: number) {
    return this.http.get<ApplicantRolesAppliedTo[]>(this.endpoint + '/roles-applied-to/', { params: { catalyzrPersonId: catalyzrPersonId, clientId: clientId.toString() }, headers: httpOptions.headers });
  }
  getApplicantRolesToApplyTo(catalyzrPersonId: string, clientId: number) {
    return this.http.get<any>(this.endpoint + '/roles-to-apply-to/', { params: { catalyzrPersonId: catalyzrPersonId, clientId: clientId.toString() }, headers: httpOptions.headers });
  }

  getPaginatedEmployeeCareerRecommendations(catalyzrPersonId, personType, clientId, hrPersonId, pageNumber?, pageSize?) {
    const paginatedResult: PaginatedResult<JobRecommendation[]> = new PaginatedResult<JobRecommendation[]>();
    let params = new HttpParams();
    params = params.append('ClientId', clientId);
    params = params.append('CatalyzrPersonId', catalyzrPersonId);
    params = params.append('PersonType', personType);
    params = params.append('HrPersonId', hrPersonId);
    if (pageNumber != null && pageSize != null) {
      params = params.append('pageNumber', pageNumber);
      params = params.append('pageSize', pageSize);
    }
    return this.http.get<JobRecommendation[]>(this.endpoint + '/getEmployeeCareerRecommendations', { observe: 'response', params })
      .pipe(
        map(response => {
          paginatedResult.result = response.body;
          if (response.headers.get('Pagination') != null) {
            paginatedResult.pagination = JSON.parse(response.headers.get('Pagination'));
          }
          return paginatedResult;
        })
      );
  }
  getEmployeeTopLearningPrograms(clientId: number, catalyzrPersonId: string) {
    return this.http.get(this.endpoint + '/getEmployeeTopLearningPrograms', { params: { ClientId: clientId.toString(), CatalyzrPersonId: catalyzrPersonId }, headers: httpOptions.headers });
  }
  getPaginatedEmployeeLearningPrograms(clientId: number, catalyzrPersonId: string, cipCode: string, pageNo?, pageSize?) {
    const paginatedResult: PaginatedResult<VWEmployeeLearningProgram[]> = new PaginatedResult<VWEmployeeLearningProgram[]>();

    let params = new HttpParams();
    params = params.append('clientId', clientId.toString());
    params = params.append('catalyzrPersonId', catalyzrPersonId);
    params = params.append('CIPCode', cipCode);
    if (pageNo != null && pageSize != null) {
      params = params.append('pageNumber', pageNo);
      params = params.append('pageSize', pageSize);
    }

    return this.http.get<VWEmployeeLearningProgram[]>(this.endpoint + '/getPaginatedEmployeeLearningPrograms', { observe: 'response', params })
      .pipe(
        map(response => {
          paginatedResult.result = response.body;
          if (response.headers.get('Pagination') != null) {
            paginatedResult.pagination = JSON.parse(response.headers.get('Pagination'));
          }
          return paginatedResult;
        })
      );
  }

  // get the employee total test count
  getEmployeeTotalTestCount(clientId, catalyzrPersonId) {
    return this.http.get(this.baseUrl + 'employees/getEmployeeCompletedTestCount/' + catalyzrPersonId + '/person/' + clientId + '/client', { headers: httpOptions.headers });
  }
  getPersonAssessmentCompletePercentage(clientId, catalyzrPersonId) {
    return this.http.get(this.baseUrl + 'employees/getPersonAssessmentCompletePercentage/' + catalyzrPersonId + '/person/' + clientId + '/client', { headers: httpOptions.headers });
  }

  getPaginatedHRRecommendedJobsForEmployee(catalyzrPersonId, clientId, hrPersonId, pageNumber?, pageSize?) {
    const paginatedResult: PaginatedResult<HRRecommendedJobsForEmployee[]> = new PaginatedResult<HRRecommendedJobsForEmployee[]>();
    let params = new HttpParams();
    params = params.append('ClientId', clientId);
    params = params.append('CatalyzrPersonId', catalyzrPersonId);
    params = params.append('HRPersonId', hrPersonId);
    if (pageNumber != null && pageSize != null) {
      params = params.append('pageNumber', pageNumber);
      params = params.append('pageSize', pageSize);
    }
    return this.http.get<HRRecommendedJobsForEmployee[]>(this.baseUrl + 'HrLandingPage/getHRRecommendedJobsForEmployee', { observe: 'response', params })
      .pipe(
        map(response => {
          paginatedResult.result = response.body;
          if (response.headers.get('Pagination') != null) {
            paginatedResult.pagination = JSON.parse(response.headers.get('Pagination'));
          }
          return paginatedResult;
        })
      );
  }
  addCandidate(candidate: CandidateDto): Observable<any> {
    const url = `${this.endpoint}/register`;
    return this.http.post(url, candidate, { headers: httpOptions.headers })
  }
  addNewApplication(candidate: CandidateDto): Observable<any> {
    const url = `${this.endpoint}/addNewApplication`;
    return this.http.post(url, candidate, { headers: httpOptions.headers })
  }
  getCountryCodes(): Observable<CountryCode[]> {
    const url = `${this.baseUrl}lookups/countrycodes`;
    return this.http.get<CountryCode[]>(url, { headers: httpOptions.headers })
  }
  getCandidateByIdAndClientId(applicantId: string, clientId: number): Observable<any> {
    const url = `${this.endpoint}/getCandidateByIdAndClientId?applicantId=${applicantId}&clientId=${clientId}`;
    return this.http.get<any>(url);
  }
  getCatalyzrPerson(
    clientId: Number,
    personId: string
  ): Observable<EmployeeSummariesOutputDto> {
    return this.http.get<EmployeeSummariesOutputDto>(
      this.endpoint + "/getPerson/" + clientId + "/" + personId
    );
  }
}
